import type { UiLanguage } from "@t3tools/contracts/settings";

export type ResolvedUiLanguage = "en" | "tr";

export function detectSystemUiLanguage(
  languages: ReadonlyArray<string> = typeof navigator === "undefined"
    ? []
    : navigator.languages.length > 0
      ? navigator.languages
      : [navigator.language],
): ResolvedUiLanguage {
  return languages.some((language) => language.toLowerCase().startsWith("tr")) ? "tr" : "en";
}

export function resolveUiLanguage(preference: UiLanguage): ResolvedUiLanguage {
  return preference === "system" ? detectSystemUiLanguage() : preference;
}

export function localeTag(language: ResolvedUiLanguage): string {
  return language === "tr" ? "tr-TR" : "en-US";
}

export function applyDocumentLanguage(language: ResolvedUiLanguage): void {
  if (typeof document === "undefined") return;
  document.documentElement.lang = localeTag(language);
}
